// import React, { useState, useEffect } from "react";
// import { Paper, Container, Typography, Grid, Button } from "@material-ui/core";
// import AddIcon from "@material-ui/icons/Add";
// import DeleteIcon from "@material-ui/icons/Delete";
// import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
// import { Styles } from "./style";
// import { decryptAes } from "../AESencryptdecrypt";

// export default function TopView({ data }) {
//   const routePath = (path) => {
//     debugger;
//     if (decryptAes(localStorage.getItem("email")) == "route") {
//       if (path == "/dashboard") {
//         window.open("/routeList", "_self");
//         return false;
//       }
//     }
//     if (path == "back") {
//       if (data.subTitleThird == "Live Tracking") {
//         window.open("/dashboard", "_self");
//       } else {
//         if (window.history.back() == undefined) {
//           if (data.backPathSecond === "/dashboard") {
//             window.open("/operations-dashboard", "_self");
//           } else {
//             window.open(data.backPathSecond, "_self");
//           }
//         } else {
//           window.open(window.history.back(), "_self");
//         }
//       }
//     } else {
//       window.open(path, "_self");
//     }
//   };

//   return (
//     <Grid container alignItems="center" style={Styles.titleContainer}>
//       <Grid
//         item
//         container
//         md={9}
//         justifyContent="flex-start"
//         alignItems="center"
//         alignContent="center"
//       >
//         {!data.hideBtn && (
//           <KeyboardBackspaceIcon
//             style={Styles.backIcon}
//             onClick={(event) => routePath("back")}
//           />
//         )}
//         <span style={Styles.spanContainer}>
//           <Typography
//             variant="h6"
//             className="text-capitalize"
//             style={Styles.typography}
//           >
//             {data.title}
//           </Typography>
//           <p style={Styles.p}>
//             <span
//               onClick={(event) => routePath(data.backPath)}
//               className="cousor_pointer"
//             >
//               {data.subTitleFirst}{" "}
//             </span>
//             {data.subTitleSecond != "Company >" && (
//               <span
//                 onClick={(event) => routePath(data.backPathSecond)}
//                 className="cousor_pointer text-capitalize"
//               >
//                 {data.subTitleSecond}
//               </span>
//             )}
//             <span className="text-capitalize" style={Styles.addSiteText}>
//               {data.subTitleThird}
//             </span>
//           </p>
//         </span>
//       </Grid>

//       <Grid container item md={3} style={{ textAlign: "right" }}>
//         <Grid item md={12}>
//           <Typography
//             gutterBottom
//             variant="subtitle1"
//             style={{ marginTop: "13px" }}
//           >
//             {data?.addButtonPermission?.length > 0 ? (
//               data?.buttonIcon ? (
//                 <Button
//                   variant="contained"
//                   className="font12 fontbold"
//                   onClick={(event) => routePath(data.addButtonPath)}
//                 >
//                   <AddIcon />
//                   {data.buttonText}
//                 </Button>
//               ) : (
//                 ""
//               )
//             ) : (
//               ""
//             )}

//             {data.export && (
//               <>
//                 {data?.exportPdf && (
//                   <Button
//                     variant="contained"
//                     onClick={(event) => data?.getExportData("pdf")}
//                   >
//                     Export Pdf
//                   </Button>
//                 )}
//                 {data?.exportExcel && (
//                   <Button
//                     variant="contained"
//                     onClick={(event) => data?.getExportData("excel")}
//                   >
//                     Export Excel
//                   </Button>
//                 )}
//               </>
//             )}

//             {data.addButton ? (
//               <>
//                 <Button
//                   className="bg-white"
//                   onClick={data.addCancelClick}
//                   variant="outlined"
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   style={{ width: "22%", marginLeft: "6px" }}
//                   variant="contained"
//                   onClick={data.addClick}
//                 >
//                   Add
//                 </Button>
//               </>
//             ) : (
//               ""
//             )}
//             {Array.isArray(data?.buttonArray) && data?.buttonArray?.length > 0
//               ? data?.buttonArray?.map(
//                   ({ name, action, handleButtonAction }) => {
//                     return (
//                       <Button
//                         style={{ marginLeft: "6px" }}
//                         variant="contained"
//                         onClick={() => handleButtonAction(action)}
//                       >
//                         {name}
//                       </Button>
//                     );
//                   }
//                 )
//               : ""}

//             {data.editButton ? (
//               <>
//                 <Button
//                   style={{ width: "9%", marginLeft: "1rem" }}
//                   variant="contained"
//                   onClick={data.editButtonClick}
//                 >
//                   Edit
//                 </Button>
//               </>
//             ) : (
//               ""
//             )}

//             {data.updatePermission.length > 0 ? (
//               data.updateButton ? (
//                 <>
//                   <Button
//                     onClick={data.goBackEditClick}
//                     variant="outlined"
//                     className="bg-white"
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     style={{ width: "9%", marginLeft: "1rem" }}
//                     variant="contained"
//                     onClick={data.updateClick}
//                   >
//                     Update
//                   </Button>
//                 </>
//               ) : (
//                 ""
//               )
//             ) : (
//               ""
//             )}
//           </Typography>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }

import React from "react";
import {
  Grid,
  Typography,
  Button,
  makeStyles,
  Box,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { decryptAes, decryptAesObj } from "../AESencryptdecrypt";

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    padding: theme.spacing(1),
    // backgroundColor: "#fff",
    // borderBottom: "1px solid #ccc",
  },
  backIcon: {
    marginRight: theme.spacing(2),
    cursor: "pointer",
    fontSize: "24px",
  },
  title: {
    fontWeight: 600,
    fontSize: "18px",
    textTransform: "capitalize",
  },
  breadcrumb: {
    // marginTop: theme.spacing(0.1),
    fontSize: "14px",
    color: "#666",
  },
  breadcrumbLink: {
    color: "#007bff",
    cursor: "pointer",
    marginRight: theme.spacing(1),
    textTransform: "capitalize",
  },
  button: {
    marginLeft: theme.spacing(1),
  },
}));

export default function TopView({ data }) {
  const classes = useStyles();
  const permissionAccess = decryptAesObj(localStorage.getItem("data"));
  const allowedIds = [711, 895]; // make this configurable
  const isShowExportExcel =
    permissionAccess?.userType === "ADMIN" ||
    allowedIds.includes(permissionAccess?.id);

  const routePath = (path) => {
    if (
      decryptAes(localStorage.getItem("email")) === "route" &&
      path === "/dashboard"
    ) {
      window.open("/routeList", "_self");
      return;
    }

    if (path === "back") {
      if (data.subTitleThird === "Live Tracking") {
        window.open("/dashboard", "_self");
      } else {
        const historyBack = window.history.back();
        if (!historyBack && data.backPathSecond) {
          window.open(data.backPathSecond, "_self");
        } else {
          window.open(historyBack, "_self");
        }
      }
    } else {
      window.open(path, "_self");
    }
  };

  return (
    <Grid container className={classes.titleContainer} alignItems="center">
      <Grid item md={5} container alignItems="center">
        {!data.hideBtn && (
          <Tooltip title="Back">
            <KeyboardBackspaceIcon
              className={classes.backIcon}
              onClick={() => routePath("back")}
            />
          </Tooltip>
        )}
        <Box>
          <Typography className={classes.title}>{data.title}</Typography>
          <div className={classes.breadcrumb}>
            {data.subTitleFirst && (
              <span
                className={classes.breadcrumbLink}
                onClick={() => routePath(data.backPath)}
              >
                {data.subTitleFirst}
              </span>
            )}
            {data.subTitleSecond !== "Company >" && data.subTitleSecond && (
              <span
                className={classes.breadcrumbLink}
                onClick={() => routePath(data.backPathSecond)}
              >
                {data.subTitleSecond}
              </span>
            )}
            <span className="text-capitalize">{data.subTitleThird}</span>
          </div>
        </Box>
      </Grid>

      <Grid item md={7} container justifyContent="flex-end">
        {data?.export && (
          <>
            {data.exportPdf && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => data.getExportData("pdf")}
                className={classes.button}
              >
                Export PDF
              </Button>
            )}
            {isShowExportExcel && data?.exportExcel && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => data.getExportData("excel")}
                className={classes.button}
              >
                Export Excel
              </Button>
            )}
          </>
        )}

        {data?.addButtonPermission?.length > 0 && data?.buttonIcon && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => routePath(data.addButtonPath)}
            startIcon={<AddIcon />}
            className={classes.button}
          >
            {data.buttonText}
          </Button>
        )}

        {data.addButton && (
          <>
            <Button
              variant="outlined"
              onClick={data.addCancelClick}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={data.addClick}
              className={classes.button}
            >
              Add
            </Button>
          </>
        )}

        {/* {Array.isArray(data?.buttonArray) &&
          data?.buttonArray?.map(
            ({ name, action, handleButtonAction, show }) => (
              <Button
                key={name}
                variant="contained"
                onClick={() => handleButtonAction(action)}
                className={classes.button}
              >
                {name}
              </Button>
            )
          )} */}

        {Array.isArray(data?.buttonArray) &&
          data?.buttonArray?.map(
            ({ name, action, handleButtonAction, show }) => {
              return (
                <>
                  {show && (
                    <Button
                      key={name}
                      variant="contained"
                      onClick={() => handleButtonAction(action)}
                      className={classes.button}
                    >
                      {name}
                    </Button>
                  )}
                </>
              );
            }
          )}

        {data.editButton && (
          <Button
            variant="contained"
            color="primary"
            onClick={data.editButtonClick}
            className={classes.button}
          >
            Edit
          </Button>
        )}

        {data?.updatePermission?.length > 0 && data.updateButton && (
          <>
            <Button
              variant="outlined"
              onClick={data.goBackEditClick}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={data.updateClick}
              className={classes.button}
            >
              Update
            </Button>
          </>
        )}
      </Grid>
    </Grid>
  );
}
